import measurementChannels from "./MeasurementChannel";


const types = new Map();

function defineType(item) {
    types.set(item.id.toUpperCase(), item)
}

let idx = 0;
defineType({
    id:'oxygenConsumptionByWeight', order: idx++,
    label: 'VO2', short: 'VO2', unitLabel:'mL/kg/min',
    color: '#1b82c9',
    rangeMin: 0, rangeMax: 100, stepSize: 10,
    decimals: 2,
});

defineType( {
    id:'oxygenConsumption', order: idx++,
    label: 'VO2', short: 'VO2', unitLabel:'mL/min',
    color: '#1b82c9',
    rangeMin: 0, rangeMax: 1000, stepSize: 250,
    decimals: 2,
});

defineType( {
    id:'carbonDioxideProductionByWeight', order: idx++,
    label: 'VCO2', short: 'VCO2', unitLabel:'mL/kg/min',
    color: '#000000',
    rangeMin: 0, rangeMax: 100, stepSize: 10,
    decimals: 2,
});

defineType( {
    id:'carbonDioxideProduction', order: idx++,
    label: 'VCO2', short: 'VCO2', unitLabel:'mL/min',
    color: '#000000',
    rangeMin: 0, rangeMax: 1000, stepSize: 250,
    decimals: 2,
});

defineType( {
    id:'respiratoryExchangeRatio', order: idx++,
    label: 'Respiratory Exchange Ratio', short: 'RER',
    color: '#00008B',
    rangeMin: 0, rangeMax: 1, stepSize: 0.1,
    decimals: 2,
});

defineType( {
    id:'heartRate', order: idx++,
    label: 'Heart Rate', short: 'HR', unitLabel:'bpm',
    color: '#FF0000',
    rangeMin: 1, rangeMax: 150, stepSize: 10,
    decimals: 0,
});

defineType( {
    id:'cyclingPower', order: idx++,
    label: 'Power', short: 'Power', unitLabel:'watts',
    color: '#1b82c9',
    rangeMin: 0, rangeMax: 80, stepSize: 10,
    decimals: 2,
});

defineType( {
    id:'respiratoryFrequency', order: idx++,
    label: 'Respiratory Frequency', short: 'Rf', unitLabel:'bpm',
    color: '#00CED1',
    rangeMin: 1, rangeMax: 80, stepSize: 10,
    decimals: 2,
});

defineType( {
    id:'tidalVolume', order: idx++,
    label: 'Tidal Volume', short: 'Tv', unitLabel:'L',
    color: '#e69900',
    rangeMin: 0, rangeMax: 5.0, stepSize: 1,
    decimals: 2,
});

defineType( {
    id:'ventilation', order: idx++,
    label: 'Ventilation', short: 'Ve', unitLabel:'L/min',
    color: '#2E8B57',
    rangeMin: 0, rangeMax: 50, stepSize: 20,
    decimals: 2,
});

defineType( {
    id:'smO2', order: idx++,
    label: 'Muscle Oxygenation', short: 'SmO2', unitLabel:'%',
    color: '#8A2BE2',
    rangeMin: 0, rangeMax: 50, stepSize: 10,
    decimals: 2,
});

defineType( {
    id:'tHb', order: idx++,
    label: 'Total Hemoglobin', short: 'THb', unitLabel:'THb',
    color: '#FF0000',
    rangeMin: 0, rangeMax: 10, stepSize: 0.1,
    decimals: 3,
});

defineType( {
    id:'cadence', order: idx++,
    label: 'Cadence', short: 'RPM', unitLabel:'rpm',
    color: '#FF8C00',
    rangeMin: 0, rangeMax: 60, stepSize: 10,
    decimals: 2,
});

defineType( {
    id:'speed', order: idx++,
    label: 'Speed', short: 'Speed', unitLabel:'km/h',
    color: '#BC8F8F',
    rangeMin: 0, rangeMax: 60, stepSize: 5,
    decimals: 2,
});

defineType( {
    id:'spO2', order: idx++,
    label: 'Pulse Oxygenation', short: 'SpO2', unitLabel:'%',
    color: '#8A2BE2',
    rangeMin: 0, rangeMax: 100, stepSize: 10,
    decimals: 2,
});

defineType( {
    id:'distance', order: idx++,
    label: 'Distance', short: 'Dist', unitLabel:'km',
    color: '#6495ED',
    rangeMin: 0, rangeMax: 50, stepSize: 5,
    decimals: 2,
});

defineType( {
    id:'elevation', order: idx++,
    label: 'Elevation', short: 'Elevation', unitLabel:'m',
    color: '#FFEBCD',
    rangeMin: 0, rangeMax: 150, stepSize: 50,
    decimals: 2,
});

defineType( {
    id:'ventilationVO2', order: idx++,
    label: 'Ventilation by VO2', short: 'Ve/VO2', unitLabel:'%',
    color: '#6495ED',
    rangeMin: 0, rangeMax: 50, stepSize: 10,
    decimals: 2,
});

defineType( {
    id:'eqO2', order: idx++,
    label: 'Ventilatory Equivalents for Oxygen', short: 'EqO2', unitLabel:'%',
    color: '#4455EE',
    rangeMin: 0, rangeMax: 50, stepSize: 10,
    decimals: 2,
});

defineType( {
    id:'eqCo2', order: idx++,
    label: 'Ventilatory Equivalents for CO2', short: 'EqCO2', unitLabel:'%',
    color: '#3344CC',
    rangeMin: 0, rangeMax: 50, stepSize: 10,
    decimals: 2,
});

defineType( {
    id:'fractionOfExpiredOxygen', order: idx++,
    label: 'Fraction Of Expired Oxygen', short: 'FeO2',
    unitLabel:'%',
    color: '#DA70D6',
    rangeMin: 0, rangeMax: 21, stepSize: 0.5,
    decimals: 2,
});

defineType( {
    id:'fractionOfExpiredCO2', order: idx++,
    label: 'Fraction of Expired CO2', short: 'FeCO2',
    color: '#808080',
    rangeMin: 0, rangeMax: 21, stepSize: 0.5,
    decimals: 2,
});

defineType( {
    id:'ambientPressure', order: idx++,
    label: 'Ambient Pressure', short: 'Pressure', unitLabel:'hPa',
    color: '#8B0000',
    rangeMin: 0, rangeMax: 50, stepSize: 10,
    decimals: 2,
});

defineType( {
    id:'flowSensorTemp', order: idx++,
    label: 'Device Temperature', short: 'Temp', unitLabel:'C',
    color: '#000000',
    rangeMin: 0, rangeMax: 10, stepSize: 1,
    decimals: 2,
});

defineType( {
    id:'oxygenSensorHumidity', order: idx++,
    label: 'Oxygen Sensor Humidity', short: 'HUM', unitLabel:'%RH',
    color: '#008B8B',
    rangeMin: 0, rangeMax: 10, stepSize: 2,
    decimals: 2,
});

defineType( {
    id:'ambientO2', order: idx++,
    label: 'Ambient Oxygen Concentration', short: 'AMB O2', unitLabel:'%',
    color: '#9932CC',
    rangeMin: 0, rangeMax: 5, stepSize: 0.1,
    decimals: 2,
});

defineType( {
    id:'ambientCO2', order: idx++,
    label: 'Ambient Carbon Dioxide Concentration', short: 'AMB CO2', unitLabel:'ppm',
    color: '#606060',
    rangeMin: 0, rangeMax: 5, stepSize: 0.1,
    decimals: 2,
});

defineType( {
    id:'longitude', order: idx++,
    label: 'Longitude', short: 'Long', unitLabel:'deg',
    color: '#000000',
    rangeMin: 0, rangeMax: 10, stepSize: 0.01,
    decimals: 4,
});

defineType( {
    id:'latitude', order: idx++,
    label: 'Latitude', short: 'Lat', unitLabel:'deg',
    color: '#808080',
    rangeMin: 0, rangeMax: 10, stepSize: 0.01,
    decimals: 4,
});



defineType( {
    id:'heartRRInterval', order: idx++,
    label: 'Heart RR Interval', short: 'RR', unitLabel:'ms',
    color: '#8B0000',
    rangeMin: 0, rangeMax: 500, stepSize: 25,
    decimals: 2,
});

defineType( {
    id:'elapsed', order: idx++,
    label: 'Elapsed Time', short: 'Elapsed',
    color: '#808080',
    decimals: 2, });

defineType({
    id:'remainingStepTime', order: idx++,
    label: 'Remaining Time', short: 'Time Remaining',
    color: '#808080',
    decimals: 2, });

defineType({
    id:'phaseType', order: idx++,
    label: 'Current Phase', short: 'Current Phase',
    color: '#808080',
    decimals: 0, });

defineType({
    id:'stepSpeedIntensity', order: idx++,
    label: 'Target Speed', short: 'Target Speed',
    color: '#808080',
    fill: true,
    fillColor: 'rgba(150,150,150,0.4)',
    decimals: 2,
    yAxisPosition: 'right'
});

defineType( {
    id:'stepPowerIntensity', order: idx++,
    label: 'Target Power', short: 'Target Power',
    color: '#808080',
    fill: true,
    fillColor: 'rgba(150,150,150,0.4)',
    decimals: 2,
    yAxisPosition: 'right'
});

defineType( {
    id:'temperature', order: idx++,
    label: 'Temperature', short: 'Temp', unitLabel:'°C',
    color: '#FF6347',
    decimals: 2,
});

defineType( {
    id:'TSI', order: idx++,
    label: 'Tissue Saturation', short: 'TSI', unitLabel:'%',
    color: '#8A2BE2',
    rangeMin: 0, rangeMax: 100, stepSize: 5,
    decimals: 2,
});

defineType( {
    id:'hbDiff', order: idx++,
    label: 'Hemoglobin Diff', short: 'HbDiff', unitLabel:'HbDiff',
    color: '#FF0000',
    rangeMin: 0, rangeMax: 100, stepSize: 1,
    decimals: 3,
});

defineType( {
    id:'muscleState', order: idx++,
    label: 'Muscle State', short: 'MuscleState', unitLabel:'',
    color: '#FF6600',
    rangeMin: 0, rangeMax: 12, stepSize: 1,
    decimals: 0,
});

defineType( {
    id:'bodyTemp', order: idx++,
    label: 'Body Temperature', short: 'BTemp', unitLabel:'°C',
    color: '#8A2BE2',
    decimals: 2,
});

defineType( {
    id:'skinTemp', order: idx++,
    label: 'Skin Temperature', short: 'STemp', unitLabel:'°C',
    color: '#FF6347',
    decimals: 2,
});

defineType( {
    id:'oxygenConsumptionCalorie', order: idx++,
    label: 'Calorie Consumption', short: 'Calorie', unitLabel:'kcal/hr',
    color: '#BF1551',
    decimals: 0,
});

defineType( {
    id:'heartRateVariability', order: idx++,
    label: 'Heart Rate Variability', short: 'HRV', unitLabel:'',
    color: '#AC1555',
    decimals: 0,
});

defineType( {
    id:'inclination', order: idx++,
    label: 'Inclination', short: 'Inclination', unitLabel:'',
    color: '#4CA585',
    decimals: 0,
});

defineType( {
    id:'stepInclination', order: idx++,
    label: 'Step Inclination', short: 'Step Inclination', unitLabel:'',
    color: '#4CA585',
    decimals: 0,
});


const measurementTypes = {

    RespiratoryFrequency: 'respiratoryFrequency',
    TidalVolume: 'tidalVolume',
    Ventilation: 'ventilation',
    FractionOfExpiredOxygen: 'fractionOfExpiredOxygen',
    FractionOfExpiredCO2: 'fractionOfExpiredCO2',
    OxygenConsumption: 'oxygenConsumption',
    OxygenConsumptionByWeight: 'oxygenConsumptionByWeight',
    CarbonDioxideProduction: 'carbonDioxideProduction',
    CarbonDioxideProductionByWeight: 'carbonDioxideProductionByWeight',
    RespiratoryExchangeRatio: 'respiratoryExchangeRatio',
    AmbientO2: 'ambientO2',
    AmbientCO2: 'ambientCO2',
    AmbientPressure: 'ambientPressure',
    VentilationVO2: 'ventilationVO2',
    EqO2: 'eqO2',
    EqCO2: 'eqCo2',
    HeartRate: 'heartRate',
    HeartRRInterval: 'heartRRInterval',
    SmO2: 'smO2',
    THb: 'tHb',
    Speed: 'speed',
    Cadence: 'cadence',
    CyclingPower: 'cyclingPower',
    Temperature: 'temperature',
    TSI: 'tsi',
    HbDiff: 'hbDiff',
    MuscleState: 'muscleState',
    BodyTemp: 'bodyTemp',
    SkinTemp: 'skinTemp',
    OxygenConsumptionCalorie: 'oxygenConsumptionCalorie',
    HeartRateVariability: 'heartRateVariability',
    Inclination: 'inclination',

    StepSpeedIntensity: 'stepSpeedIntensity',
    StepPowerIntensity: 'stepPowerIntensity',
    StepInclination: 'stepInclination',

    find(type) {
        let found = types.get(type.toUpperCase());
        return found ?? {
            id: type,
            label: type, short: type,
            color: '#1b82c9',
            decimals: 2,
        };
    },

    match(m1, m2) {
        if(!m1 || !m2)
            return false;
        if(m1.id && m2.id)
            return m1.id == m2.id;
        if(m1.id && (m1.id == m2))
            return true;
        if(m2.id && (m2.id == m1))
            return true;
        if(m1 == m2)
            return true;

        return false;
    },

    createIdentifier( measurementType, measurementChannel) {
        let result = measurementType.id;
        if (measurementChannel && measurementChannel != measurementChannels.Default) {
            result += '_' + measurementChannel;
        }
        return result;
    }
};

export default measurementTypes